module.exports = "../fonts/location.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/location.svg
// module id = 389
// module chunks = 0